export const circlePeri = (radius) => 2 * Math.PI * radius;
export const percentPeri = (radius, percent) =>
  circlePeri(radius) - circlePeri(radius) * (percent / 100);



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-inner/doughnut-inner-utils.js